// extracted by mini-css-extract-plugin
export default {"relateShortRecom":"index_relateShortRecom_dRsIm"};